<template>

    <div>
        FILE UPLOAD File: {{file ? file.name : 'not selected'}}
        <br>STATE:{{state}} URL: {{url}}<br>
        <span v-if="url !== null">
            <img height="50px" :src="url">
        </span>

        <span v-if="state === 'running'">
            <v-progress-linear v-model="progress"></v-progress-linear>
        </span>
        <v-btn prepend-icon="attach_file" class="primary" @click="pickFile">Subir Archivo</v-btn>
        <input type="file" ref="file_input" accept=".csv,.ods,.txt,.pdf,image/*" @change="onFilePicked">

        <div class="dropbox">
            <!-- <input ref="file_input2" type="file" multiple :name="uploadFieldName" :disabled="isSaving" @change=" fileCount = $event.target.files.length" accept="image/*" class="input-file"> -->
            <input ref="file_input2" type="file" multiple :name="uploadFieldName" :disabled="isSaving" @change="filesChanged($event.target.name, $event.target.files, $event.target.accept); fileCount = $event.target.files.length" accept="image/*" class="input-file">
            <!-- <p v-if="isInitial"> -->
            <p v-if="state !=='running'">
                Drag your file(s) here to begin<br> or click to browse
            </p>
            <!-- <p v-if="isSaving"> -->
            <p v-if="state==='running'">
                Uploading {{ fileCount }} files...
            </p>
        </div>
        {{fileCount}}
        <ul>
            <li v-for="file in files" :key="file">{{file}}</li>
        </ul>

        <v-btn @click="uploadFiles">Upload Now</v-btn>

        <v-alert>{{error}}</v-alert>
    </div>

</template>

<script>
import firebase from "firebase/app";
import "firebase/storage";
import { mapGetters } from "vuex";

export default {
  data: () => ({
    file: null,
    url: null,
    uploadedFiles: null,
    state: "",
    progress: 0,
    uploadFieldName: "uploadfield",
    isSaving: false,
    files: [],
    fileCount: 0,
    dataStorageFolder: "data",
    imageStorageFolder: "public"
  }),
  computed: {
    ...mapGetters(["error", "loading"])
  },
  // file.type : ['image/tiff' , 'image/jpeg', 'image/png', 'image/gif']
  // file.type : ['application/pdf' , 'application/vnd.oasis.opendocument.spreadsheet' <-ods, 'text/plain', 'text/csv']
  // file.name , file.size, file.lastModified, file.lastModifiedDate, file.type

  methods: {
    filesChanged(name, files) {
      this.files.length = 0
      Array.from(Array(files.length).keys()).map(x => {
        this.files.push(files[x].name);
      });

      //   this.files = files.map(i => name + "/" + i.name);
    },
    pickFile() {
      this.$refs.file_input.click();
    },
    onFilePicked(e) {
      const files = e.target.files;
      if (files[0] !== undefined) {
        this.file = files[0];

        const ref = firebase.storage().ref();
        //const file = document.querySelector("#photo").files[0];
        const file = this.file;
        const name = +new Date() + "-" + file.name;
        const metadata = {
          contentType: file.type
        };
        const task = ref.child(name).put(file, metadata);
        task.on(
          "state_changed",
          function(snapshot) {
            // Observe state change events such as progress, pause, and resume
            // Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
            this.progress =
              snapshot.bytesTransferred / snapshot.totalBytes * 100;
            switch (snapshot.state) {
              case firebase.storage.TaskState.PAUSED: // or 'paused'
                this.state = "paused";
                break;
              case firebase.storage.TaskState.RUNNING: // or 'running'
                this.state = "running";
                break;
            }
          }.bind(this),
          function(error) {
            // Handle unsuccessful uploads
            this.$store.commit("setError", error);
          }.bind(this),
          function() {
            // Handle successful uploads on complete
            // For instance, get the download URL: https://firebasestorage.googleapis.com/...
            this.state = "done";
            task
              .then(snapshot => snapshot.ref.getDownloadURL())
              .then(url => {
                this.progress = 0;
                this.url = url;
              })
              .catch(error => {
                this.$store.commit("setError", error);
              });
          }.bind(this)
        );
      }
    },
    uploadFiles() {
      const files = this.$refs.file_input2.files;

      //const files = e.target.files;
      //  if (files[0] !== undefined) {
      //  this.file = files[0];
      if (files && files.length > 0) {
        const ref = firebase.storage().ref();
        //const file = document.querySelector("#photo").files[0];
        const uploadedFiles = [];
        let promises = [];
        let folder = "userfiles/";

        Array.from(Array(files.length).keys()).map(i => {
          let file = files[i];
          // eslint-disable-next-line
          console.log(file)
          //   const file = this.file;
          let fileData = {};
          fileData.name = +new Date() + "-" + file.name;

          let metadata = {
            contentType: file.type
          };
          let task = ref.child(folder + fileData.name).put(file, metadata);
          fileData.path = task.path;
          let p = new Promise((resolve, reject) => {
            task.on(
              "state_changed",
              function(snapshot) {
                // Observe state change events such as progress, pause, and resume
                // Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
                this.progress =
                  snapshot.bytesTransferred / snapshot.totalBytes * 100;
                switch (snapshot.state) {
                  case firebase.storage.TaskState.PAUSED: // or 'paused'
                    this.state = "paused";
                    break;
                  case firebase.storage.TaskState.RUNNING: // or 'running'
                    this.state = "running";
                    break;
                }
              }.bind(this),
              function(error) {
                // Handle unsuccessful uploads
                //this.$store.commit("setError", error);
                reject(error);
              }.bind(this),
              function() {
                // Handle successful uploads on complete
                // For instance, get the download URL: https://firebasestorage.googleapis.com/...
                this.state = "done";
                task
                  .then(snapshot => snapshot.ref.getDownloadURL())
                  .then(url => {
                    this.progress = 0;
                    fileData.url = url;
                    uploadedFiles.push(fileData);
                    resolve(fileData);
                  })
                  .catch(error => {
                    // this.$store.commit("setError", error);
                    reject(error);
                  });
              }.bind(this)
            );
          });
          promises.push(p);
        });
        Promise.all(promises).then(() => {
          alert("all done");
        });
      }
    }
  }
};
</script>

<style scoped>
.dropbox {
  outline: 2px dashed grey;
  /* the dash box */
  outline-offset: -10px;
  background: lightcyan;
  color: dimgray;
  padding: 10px 10px;
  min-height: 200px;
  /* minimum height */
  position: relative;
  cursor: pointer;
}
.input-file {
  opacity: 0;
  /* invisible but it's there! */
  width: 100%;
  height: 200px;
  position: absolute;
  cursor: pointer;
}
.dropbox:hover {
  background: lightblue;
  /* when mouse over to the drop zone, change color */
}
.dropbox p {
  font-size: 1.2em;
  text-align: center;
  padding: 50px 0;
}
</style>
